import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "ai-image"
};
const _hoisted_2 = {
  class: "left"
};
const _hoisted_3 = {
  class: "segmented"
};
const _hoisted_4 = {
  class: "modal-switch-container"
};
const _hoisted_5 = {
  class: "main"
};
import ImageList from './components/ImageList.vue';
import { AiPlatformEnum } from '@/views/aip/utils/constants';
import Dall3 from './components/dall3/index.vue';
import Midjourney from './components/midjourney/index.vue';
import StableDiffusion from './components/stableDiffusion/index.vue';
import Common from './components/common/index.vue';
import { ModelApi } from '@/api/ai/model/model';
import { AiModelTypeEnum } from '@/views/aip/utils/constants';
import { nextTick, onMounted, ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const imageListRef = ref(); // image 列表 ref
    const dall3Ref = ref(); // dall3(openai) ref
    const midjourneyRef = ref(); // midjourney ref
    const stableDiffusionRef = ref(); // stable diffusion ref
    const commonRef = ref(); // stable diffusion ref
    // 定义属性
    const selectPlatform = ref('common'); // 选中的平台
    const platformOptions = [{
      label: '通用',
      value: 'common'
    },
    // {
    //   label: 'DALL3 绘画',
    //   value: AiPlatformEnum.OPENAI
    // },
    // {
    //   label: 'MJ 绘画',
    //   value: AiPlatformEnum.MIDJOURNEY
    // },
    {
      label: 'SD 绘图',
      value: AiPlatformEnum.STABLE_DIFFUSION
    }];
    const models = ref([]); // 模型列表
    /** 绘画 start  */
    const handleDrawStart = async platform => {};
    /** 绘画 complete */
    const handleDrawComplete = async platform => {
      await imageListRef.value.getImageList();
    };
    /** 重新生成：将画图详情填充到对应平台 */
    const handleRegeneration = async image => {
      // 切换平台
      selectPlatform.value = image.platform;
      // 根据不同平台填充 image
      await nextTick();
      if (image.platform === AiPlatformEnum.MIDJOURNEY) {
        midjourneyRef.value.settingValues(image);
      } else if (image.platform === AiPlatformEnum.OPENAI) {
        dall3Ref.value.settingValues(image);
      } else if (image.platform === AiPlatformEnum.STABLE_DIFFUSION) {
        stableDiffusionRef.value.settingValues(image);
      }
      // TODO @fan：貌似 other 重新设置不行？
    };
    /** 组件挂载的时候 */
    onMounted(async () => {
      // 获取模型列表
      models.value = await ModelApi.getModelSimpleList(AiModelTypeEnum.IMAGE);
    });
    return (_ctx, _cache) => {
      const _component_el_segmented = _resolveComponent("el-segmented");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_segmented, {
        modelValue: selectPlatform.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectPlatform.value = $event),
        options: platformOptions
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [selectPlatform.value === 'common' ? (_openBlock(), _createBlock(Common, {
        key: 0,
        ref_key: "commonRef",
        ref: commonRef,
        models: models.value,
        onOnDrawComplete: handleDrawComplete
      }, null, 8, ["models"])) : _createCommentVNode("", true), selectPlatform.value === _unref(AiPlatformEnum).OPENAI ? (_openBlock(), _createBlock(Dall3, {
        key: 1,
        ref_key: "dall3Ref",
        ref: dall3Ref,
        models: models.value,
        onOnDrawStart: handleDrawStart,
        onOnDrawComplete: handleDrawComplete
      }, null, 8, ["models"])) : _createCommentVNode("", true), selectPlatform.value === _unref(AiPlatformEnum).MIDJOURNEY ? (_openBlock(), _createBlock(Midjourney, {
        key: 2,
        ref_key: "midjourneyRef",
        ref: midjourneyRef,
        models: models.value
      }, null, 8, ["models"])) : _createCommentVNode("", true), selectPlatform.value === _unref(AiPlatformEnum).STABLE_DIFFUSION ? (_openBlock(), _createBlock(StableDiffusion, {
        key: 3,
        ref_key: "stableDiffusionRef",
        ref: stableDiffusionRef,
        models: models.value,
        onOnDrawComplete: handleDrawComplete
      }, null, 8, ["models"])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_5, [_createVNode(ImageList, {
        ref_key: "imageListRef",
        ref: imageListRef,
        onOnRegeneration: handleRegeneration
      }, null, 512)])]);
    };
  }
});